<!--
  Copyright (C) 2022 Sber

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

  http://www.apache.org/licenses/LICENSE-2.0

  In any derivative products, you must retain the information of
  owner of the original code and provide clear attribution to the project

  https://dochub.info

  The use of this product or its derivatives for any purpose cannot be a secret.


  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.

  Maintainers:
    Sergeev Viktor, Sber - 2025

  Contributors:
    Sergeev Viktor <sergeevviktor017@gmail.com>, Sber - 2025
    Konstantin Myachin <kvmyachin@gmail.com>, Sber - 2026
-->

<template>
  <div class="server-updated-toast">
    <div class="server-updated-toast__title">Сервер обновлен</div>
    <div>Перезагрузите страницу, чтобы продолжить работу с новой версией.</div>
  </div>
</template>
<!-- Стили scoped и действуют только внутри уведомления.
     Рамка, фон и значок уведомления — общий стиль .dh-toast (alerts.css) -->
<style scoped>
.server-updated-toast {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.server-updated-toast__title {
  color: var(--dh-alert-text);
  font-weight: 600;
}
</style>
